export default "__VITE_ASSET__CFc0NZQK__"